<common-ui-components-page-layout
  [title]="'جستجو'"
  [showBorder]="false"
>
  <div class="hub-search d-flex flex-column align-items-stretch justify-content-start gap-plus w-100 h-100 pt-plus">
    <div class="px-plus">
      <common-ui-components-search
        [placeHolder]="'جستجو در خدمات'"
        (searchTextChange)="doSearch($event)"
        [isLoading]="servicesLoading()"
        [(searchText)]="searchText"
        #searchComponent
      ></common-ui-components-search>
    </div>
    @if (searching() || searched()) {
      <div class="px-plus d-flex flex-column align-items-stretch justify-content-start gap-minus flex-grow">
        @if (searching()) {
          @for (item of rangeCreator(3); track $index) {
            <hub-applet-search-result [isLoading]="true"></hub-applet-search-result>
          }
        } @else {
          @if (showingServices().length) {
            @for (service of showingServices(); track $index) {
              <hub-applet-search-result
                (clicked)="handleResultClick($event)"
                [service]="service"
              ></hub-applet-search-result>
            }
          } @else {
            <div class="flex-grow d-flex align-items-center justify-content-center">
              <common-ui-components-no-item></common-ui-components-no-item>
            </div>
          }
        }
      </div>
    } @else {
      <common-app-services-grouped-app-services
        (clickOnService)="clickOnService($event)"
        [category]="appServicesCategoriesConst[AppServiceCategoryNamesEnum.SUGGESTED_SERVICES]"
        [services]="services()"
        [isLoading]="servicesLoading()"
      ></common-app-services-grouped-app-services>
    }
  </div>
</common-ui-components-page-layout>
